import axios from "axios";
import { message } from "antd";

const apiClient = axios.create({
    baseURL: "/api",
    timeout: 10000,
    headers: {
        "Content-Type": "application/json",
    },
});

// Request interceptor
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor
apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response) {
            const { status, data } = error.response;

            switch (status) {
                case 401:
                    // Token expired or invalid
                    localStorage.removeItem("token");
                    delete apiClient.defaults.headers.common["Authorization"];
                    if (window.location.pathname !== "/login") {
                        window.location.href = "/login";
                    }
                    break;
                case 403:
                    message.error("Access denied");
                    break;
                case 404:
                    message.error("Resource not found");
                    break;
                case 429:
                    message.error("Too many requests. Please try again later.");
                    break;
                case 500:
                    message.error("Server error. Please try again later.");
                    break;
                default:
                    if (data?.message) {
                        message.error(data.message);
                    }
            }
        } else if (error.request) {
            message.error("Network error. Please check your connection.");
        } else {
            message.error("An unexpected error occurred.");
        }

        return Promise.reject(error);
    }
);

// WhatsNews API
export const getWhatsNews = (params) => apiClient.get("/whatsnews", { params }); // admin list
export const getWhatsNewsById = (id) => apiClient.get(`/whatsnews/${id}`); // admin get one
export const createWhatsNews = (data) => apiClient.post("/whatsnews", data); // admin create
export const updateWhatsNews = (id, data) =>
    apiClient.put(`/whatsnews/${id}`, data); // admin update
export const deleteWhatsNews = (id) => apiClient.delete(`/whatsnews/${id}`); // admin delete

// Partner API
export const getPartners = (params) => apiClient.get("/partners", { params });
export const getPartnerById = (id) => apiClient.get(`/partners/${id}`);
export const createPartner = (data) => apiClient.post("/partners", data);
export const updatePartner = (id, data) =>
    apiClient.put(`/partners/${id}`, data);
export const deletePartner = (id) => apiClient.delete(`/partners/${id}`);
export const crawlPartner = (shopifyAppUrl) =>
    apiClient.post("/partners/crawl", { shopifyAppUrl });
export const crawlAllPartners = () => apiClient.post("/partners/crawl-all");

export const getFaqs = (params) => apiClient.get("/faqs", { params }); // admin list
export const createFaq = (data) => apiClient.post("/faqs", data); // admin create
export const updateFaq = (id, data) => apiClient.put(`/faqs/${id}`, data);
export const deleteFaq = (id) => apiClient.delete(`/faqs/${id}`);

export default apiClient;
